import { RegularSizeValue, SizeType } from "common-ts/dist/models/Cart";
import {
    BodyMeasurements,
    BodyMeasurementsForSize,
    BodyMeasurementsKey,
    CalculateClothBodyMeasurementsFromBodyMeasurements,
    CalculateClothingMeasurementsFromBodyMeasurements,
    ClothingMeasurementsKey,
    ClothingType,
    CompleteBodyMeasurements,
    FitType,
    RoundClothingMeasurementsToHalfPoint,
    UserBodyMeasurements, 
} from "common-ts/dist/models/UserMeasurements";
import { 
    inputBodyMeasurementsForm, 
    postBodyMeasurement,
    postClothingMeasurementPreference,
    resetUserMeasurementList
} from "../redux/MeasurementsRedux";
import { useAppDispatch, useAppSelector } from "../reduxhooks";
import {
    OfflineActiveScreen,
} from "../redux/UIOverlayOfflineRedux";
import PersonalSizeResult from './OverlayViewUniversalSize4Result';
import SignUp from "./OverlayViewOffline0SignUpStart";
import NameIntro from "./OverlayViewOffline0NameIntro";
import BenefitStart from "./OverlayViewOffline1BenefitStart";
import MeasureOffline from "./OverlayViewOffline1SizeSelect";
import AddressInput from "./OverlayViewOffline4AddressInput";
import PersonalSizeResultLoading from './OverlayViewUniversalSize3ResultLoading';
import ProductOption from "./OverlayViewOffline3ProductOption";
import SizeResult from "./OverlayViewOffline2SizeResult";
import SizePreset from "./OverlayViewOffline1SizePreset"; // C1
import { updateState } from "../redux/AccountRedux";
import { useEffect, useState } from "react";
import { MicrophoneState } from "../redux/MicrophoneRedux";
import { Box } from "@material-ui/core";
import OverlayViewPersonalFitModifySize from './OverlayViewPersonalSizeDetail2Edit';

// Interfaces
export interface FlowSelectionData {
    firstName: string;
    microphoneState: MicrophoneState;
}

export interface FlowStateData {
    currentScreen: OfflineActiveScreen;
    titleNumber: number;
    currentBodyMeasurements: BodyMeasurements;
    currentClothingType: ClothingType;
    currentRegularSizeValue: RegularSizeValue;
    manualOverride: boolean;
    firstIn: boolean;
    guidelinesData: any;
    categoryTabIndex: number | undefined;
}

// Master component
export function FlowComponentMaster(
    flowSelectionData: FlowSelectionData,
    flowStateData: FlowStateData
) {
    let children: JSX.Element[] = [];
    children = FlowComponentMensTops(flowSelectionData, flowStateData);

    return <>{children}</>;
}

// Flow component
function FlowComponentMensTops(
    flowSelectionData: FlowSelectionData,
    flowStateData: FlowStateData
) {
    let children: JSX.Element[] = [];

    switch (flowStateData.currentScreen) {
        case OfflineActiveScreen.BenefitStart:
            children.push(
                <NameIntro
                    currentName={flowSelectionData.firstName}
                    handleNext={(firstName: string) => {}}
                />
            );
            break;

        case OfflineActiveScreen.SizePreset: // C1
            children.push(
                <SizePreset
                    handleBack={() => {}}
                    handleSelect={(measurements: BodyMeasurements, size: RegularSizeValue) => {}}
                    forceChosenSize={flowStateData.currentRegularSizeValue}
                />
            );
            break;

        case OfflineActiveScreen.SizeSelect:
            const usedMeas = flowStateData.currentBodyMeasurements ?? {};
            children.push(
            <Box style={{margin: '21px'}}>
              <OverlayViewPersonalFitModifySize
                startingClothingBodyMeasurements={ // B-complete, CB-optional
                  CompleteBodyMeasurements(usedMeas, 
                    RegularSizeValue.L)}
                startingClothingBodyMeasurementsCBComplete={ // CB-complete
                  CalculateClothBodyMeasurementsFromBodyMeasurements(ClothingType.Body, 
                    FitType.RegularFit, 
                    usedMeas, 
                    RegularSizeValue.L, [])}
                startingClothingMeasurements={ // AUTOCOMPLETE THE CB. USE CB-COMPLETE
                  RoundClothingMeasurementsToHalfPoint(
                  CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, 
                    FitType.RegularFit, 
                    usedMeas, 
                    RegularSizeValue.L))}
                startingRawClothingMeasurements={ // AUTOCOMPLETE THE CB. USE CB-COMPLETE
                  CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, 
                    FitType.RegularFit, 
                    usedMeas, 
                    RegularSizeValue.L)}
                forceClothingMeasurementsValue={flowStateData.currentBodyMeasurements}
                forceGuidelinesData={flowStateData.guidelinesData}
                handleSubmit={(value, valueClothing, lastUpdatedMeasurementsList) => {}}
                isMinimized={false}
              />
            </Box>);
            break;
        
        case OfflineActiveScreen.BenefitMiddle:
            children.push(
                <BenefitStart
                isStoreScreen={false}
                    handleBack={() => {}}
                    handleNext={() => {}}
                />
            );
            break;

        case OfflineActiveScreen.SizeLoading:
            children.push(<PersonalSizeResultLoading
              reductionMode={true}
              currentFlowData={{
                clothingType: ClothingType.KemejaPanjang,
                fitType: FitType.RegularFit,
                clothMeasValue: flowStateData.currentBodyMeasurements,
              }}
              onFetchMeasEstimateSuccess={() => {}}/>);
            break;

        case OfflineActiveScreen.SizeResult:
            const triggerList1: {[key: string]: {
              clothingMeasurementsKey: string // Same as the key for this dictionary
              bodyMeasurementsKey: string,
              triggerText: string
              triggerCallback: () => void
              showMeasurementAs?: 'SIZEWHEEL' | 'NUMBER'
            }} = {};
            triggerList1[ClothingMeasurementsKey.panjangLenganPendek as string] = {
              clothingMeasurementsKey: ClothingMeasurementsKey.panjangLenganPendek as string,
              bodyMeasurementsKey: BodyMeasurementsKey.panjangLenganPendek as string,
              triggerText: "",
              triggerCallback: () => {
              },
              showMeasurementAs: flowStateData.currentBodyMeasurements?.[BodyMeasurementsKey.panjangLenganPendek] ? 'NUMBER' : undefined,
            }
            triggerList1[ClothingMeasurementsKey.lebarLenganBaju as string] = {
              clothingMeasurementsKey: ClothingMeasurementsKey.lebarLenganBaju as string,
              bodyMeasurementsKey: BodyMeasurementsKey.lingkarLenganBisep as string,
              triggerText: "",
              triggerCallback: () => {
              },
              showMeasurementAs: flowStateData.currentBodyMeasurements?.[BodyMeasurementsKey.lebarLenganPendek] ? 'NUMBER' : undefined,
            }
            children.push(<PersonalSizeResult
              name={flowSelectionData?.firstName ?? 'User'}
              bodyMeasurements={flowStateData.currentBodyMeasurements ?? {}}
              firstClothingType={ClothingType.KemejaPendek}
              firstFitType={FitType.RegularFit}
              lastUpdatedMeasurementsList={{}}
              buttonTextType={'result-detail'}
              handleBack={() => {}}
              handleSubmit={() => {}}
              triggerList={triggerList1}
              forceCategoryTabIndex={flowStateData.categoryTabIndex}
            />);
            break;

        default: // ADD DEFAULT CASE
          children.push(
              <NameIntro
                  handleNext={(firstName: string) => {}}
              />
          );
          break;
    }

    return children;
}
